import React from 'react';
const LoadingSpinner: React.FC = () => {
  return <div className="min-h-screen flex items-center justify-center" data-id="element-388">
      <div className="flex flex-col items-center" data-id="element-389">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mb-4" data-id="element-390"></div>
        <p className="text-gray-600" data-id="element-391">Loading...</p>
      </div>
    </div>;
};
export default LoadingSpinner;